module.exports = __webpack_public_path__ + "img/404.a5fe3856.svg";